// extracted by mini-css-extract-plugin
export default {"fullScreenLayout":"full-screen-layout_fullScreenLayout__AY3-u"};